import React from "react";
import styled from "styled-components";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import { useTranslate } from '@tolgee/react';
import SettingsElement from "./SettingsElement";

import SettingsElementWithArrow from "./SettingsElementWithArrow";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const ContactsSettings = () => {
  const { setIsBlockUsersOpen, setIsReferralModalOpen } =
    useGenericComponentsStateService();

  const handleOpenBlockUsers = () => {
    setIsBlockUsersOpen(true);
  };
  const handleOpenRefferall = () => {
    setIsReferralModalOpen(true);
  };
  const { t } = useTranslate();
  return (
    <Container>
      <Header>
        <HeaderTitle>{t('settings.contacts')}</HeaderTitle>
      </Header>
      <ContentWrapper>
        <Content>
          <GroupSubtitle>
            {t('settings.contacts_descripton')}
          </GroupSubtitle>
          <GroupContentWrapper>
            <SettingsElementWithArrow
              text={t('profile.block_users')}
              onClick={() => handleOpenBlockUsers()}
            />
            <Separator />
            <SettingsElementWithArrow
              text={t('profile.invite_new_contact')}
              onClick={() => handleOpenRefferall()}
            />
          </GroupContentWrapper>
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default ContactsSettings;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 631px;
  width: 100%;
`;
const GroupSubtitle = styled.p`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  padding: 0 16px;
`;

const Separator = styled.div`
  display: flex;
  width: 100%;
  min-height: 1px;
  background: ${({ theme }) => theme.sidebar.borderColor};
`;
